import { useMemo } from "react";
import { ArtworkCardProps } from "../types";
import { AD_STATUS } from "../utils/enums";
import moment from "../utils/moment";

export default function useAdUtils(ad: ArtworkCardProps) {
  const isOpenForBids: boolean = useMemo(() => {
    return (
      ad?.status === AD_STATUS.ON_SALE &&
      moment().isBetween(moment(ad?.biddingStarts), moment(ad?.biddingEnds))
    );
  }, [ad?.biddingStarts, ad?.biddingEnds, ad?.status]);

  const isClosed: boolean = useMemo(() => {
    return (
      moment().isAfter(moment(ad?.biddingEnds)) &&
      (ad?.status === AD_STATUS.CLOSED || ad?.status === AD_STATUS.ON_SALE)
    );
  }, [ad?.biddingEnds, ad?.status]);

  const isUpcoming: boolean = useMemo(() => {
    return (
      moment().isBefore(moment(ad?.biddingStarts)) &&
      ad?.status === AD_STATUS.ON_SALE
    );
  }, [ad?.biddingStarts, ad?.status]);

  const isComingSoon: boolean = useMemo(() => {
    return ad?.status === AD_STATUS.APPROVED;
  }, [ad?.status]);

  const isSold: boolean = useMemo(() => {
    return ad?.status === AD_STATUS.SOLD;
  }, [ad?.status]);

  return { isOpenForBids, isClosed, isUpcoming, isComingSoon, isSold };
}
